import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFilter } from 'shared/types/filters';
import { ISearchMetaTooltip } from 'shared/types/searchMetaTooltip';

const initialState: ISearchMetaTooltip = {
  isAvailable: true,
  openedFilter: null,
  lastAppliedFilter: null,
};

export const searchMetaTooltipSlice = createSlice({
  name: 'searchMetaTooltip',
  initialState,
  reducers: {
    setSearchMetaTooltipAvailable: (state, action: PayloadAction<boolean>) => {
      state.isAvailable = action.payload;
    },
    updateOpenedFilter: (state, action: PayloadAction<TFilter | null>) => {
      state.openedFilter = action.payload;
    },
    updateLastAppliedFilter: (state, action: PayloadAction<TFilter | null>) => {
      state.lastAppliedFilter = action.payload;
    },
  },
});

export const {
  reducer: searchMetaTooltipReducer,
  name: searchMetaTooltipReducerName,
  actions: { updateLastAppliedFilter, updateOpenedFilter, setSearchMetaTooltipAvailable },
} = searchMetaTooltipSlice;
